import React from 'react'
import Style from './Logo.module.css'
export default function Logo() {
  return (
    <img src="/homeshiksha-logo.jpg" alt="logo" className={Style.logo} />
  )
}
